/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */

// THIS CODE IS GENERATED - DO NOT MODIFY
// See angular/tools/gulp-tasks/cldr/extract.js

function plural(n: number): number {
  if (n === 1) return 1;
  return 5;
}

export default [
  'ky', [['тң', 'тк'], , ['таңкы', 'түштөн кийинки']], ,
  [
    ['Ж', 'Д', 'Ш', 'Ш', 'Б', 'Ж', 'И'],
    ['жек.', 'дүй.', 'шейш.', 'шарш.', 'бейш.', 'жума', 'ишм.'],
    [
      'жекшемби', 'дүйшөмбү', 'шейшемби', 'шаршемби',
      'бейшемби', 'жума', 'ишемби'
    ],
    ['жек.', 'дүй.', 'шейш.', 'шарш.', 'бейш.', 'жума', 'ишм.']
  ],
  [
    ['Ж', 'Д', 'Ш', 'Ш', 'Б', 'Ж', 'И'],
    ['жек.', 'дүй.', 'шейш.', 'шарш.', 'бейш.', 'жума', 'ишм.'],
    [
      'жекшемби', 'дүйшөмбү', 'шейшемби', 'шаршемби',
      'бейшемби', 'жума', 'ишемби'
    ],
    ['жк', 'дш.', 'шш.', 'шр.', 'бш.', 'жм.', 'иш.']
  ],
  [
    ['Я', 'Ф', 'М', 'А', 'М', 'И', 'И', 'А', 'С', 'О', 'Н', 'Д'],
    [
      'янв.', 'фев.', 'мар.', 'апр.', 'май', 'июн.', 'июл.', 'авг.',
      'сен.', 'окт.', 'ноя.', 'дек.'
    ],
    [
      'январь', 'февраль', 'март', 'апрель', 'май', 'июнь',
      'июль', 'август', 'сентябрь', 'октябрь', 'ноябрь',
      'декабрь'
    ]
  ],
  [
    ['Я', 'Ф', 'М', 'А', 'М', 'И', 'И', 'А', 'С', 'О', 'Н', 'Д'],
    [
      'Янв', 'Фев', 'Мар', 'Апр', 'Май', 'Июн', 'Июл', 'Авг', 'Сен',
      'Окт', 'Ноя', 'Дек'
    ],
    [
      'Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь',
      'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь',
      'Декабрь'
    ]
  ],
  [
    ['б.з.ч.', 'б.з.'], ,
    ['биздин заманга чейин', 'биздин заман']
  ],
  1, [6, 0], ['d/M/yy', 'y-\'ж\'., d-MMM', 'y-\'ж\'., d-MMMM', 'y-\'ж\'., d-MMMM, EEEE'],
  ['HH:mm', 'HH:mm:ss', 'HH:mm:ss z', 'HH:mm:ss zzzz'],
  [
    '{1} {0}',
    ,
    ,
  ],
  [',', ' ', ';', '%', '+', '-', 'E', '×', '‰', '∞', 'сан эмес', ':'],
  ['#,##0.###', '#,##0%', '#,##0.00 ¤', '#E0'], 'сом', 'Кыргызстан сому', plural
];
